(function () {
  function setOrigin(event) {
    const el = event.target;
    if (!(el instanceof Element) || !el.classList.contains('button-circle')) return;

    const rect = el.getBoundingClientRect();
    const x = ((event.clientX - rect.left) / rect.width) * 100;
    const y = ((event.clientY - rect.top) / rect.height) * 100;
    el.style.setProperty('--cx', `${x}%`);
    el.style.setProperty('--cy', `${y}%`);
  }

  // Capture phase so dynamically injected buttons (e.g. quick-add modal) work
  // without per-element binding. pointerenter/leave do not bubble.
  document.addEventListener('pointerenter', setOrigin, true);
  document.addEventListener('pointerleave', setOrigin, true);
})();
